// @ts-nocheck
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
// import React, { FC } from "react";  // Starter Custom Code
// import { connect } from "react-redux"; // Starter Custom Code

/* Starter Custom Code - Start */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { getProductListDataView } from "@insite/client-framework/Store/Pages/ProductList/ProductListSelectors";
import translate from "@insite/client-framework/Translate";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Drawer, { DrawerPresentationProps } from "@insite/mobius/Drawer";
import Select, { SelectPresentationProps } from "@insite/mobius/Select";
import Tab, { TabPresentationProps } from "@insite/mobius/Tab";
import TabGroup, { TabGroupPresentationProps } from "@insite/mobius/TabGroup";
import { BreakpointKey } from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import constants from "@store/constants";
import { useContentSearchDataView } from "@store/Framework/Store/Data/ContentSearch/ContentSearchHooks";
import updateSearchFields from "@store/Framework/Store/Starter/Pages/ProductList/Handlers/UpdateSearchFields";
import { useContentSearchCurrentTab } from "@store/Framework/Store/Starter/Pages/ProductList/ProductListHooks";
import { ProductListSortSelectStyles } from "@store/Overrides/Widgets/ProductList/ProductListSortSelect";
import { boxStickyStyles } from "@store/Themes/common/mixins/box";
import { baseGridHiddenProps } from "@store/Themes/common/props/baseGrid";
import { filtersProps } from "@store/Themes/common/props/filters";
import useIsBreakpoint from "@toolkit/Framework/Common/Hooks/useIsBreakpoint";
import usePersistentDataView from "@toolkit/Framework/Common/Hooks/usePersistentDataView";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import getWidgetComponent from "@toolkit/Framework/Common/Utilities/getWidgetComponent";
import { pxToRem, pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { useSettingsCollection } from "@toolkit/Framework/Store/Context/ContextHooks";
import setIsFilterNavOpen from "@toolkit/Framework/Store/Toolkit/Pages/ProductList/Handlers/setIsFilterNavOpen";
import {
    useIsFilterNavOpen,
    useIsSearchPage,
} from "@toolkit/Framework/Store/Toolkit/Pages/ProductList/ProductListHooks";
import React, { FC, useMemo } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const SortSelect = getWidgetComponent("ProductList/ProductListSortSelect");

const mobileBreakpoint: BreakpointKey = "xs";

const wrapperStyles = () => {
    return css`
        ${breakpointValues(pxToRemArray([20, null, 25, null, 30]), "margin-top")}

        &:first-child {
            margin-top: 0;
        }
    `;
};

const mapDispatchToProps = {
    setIsFilterNavOpen,
    updateSearchFields,
};
/* Starter Custom Code - End */

const mapStateToProps = (state: ApplicationState) => ({
    view: state.pages.productList.view,
    productListDataView: getProductListDataView(state), // Starter Custom Code
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>; // Starter Custom Code

export interface ProductListColumnsStyles {
    container?: GridContainerProps;
    leftColumnGridItem?: GridItemProps;
    leftColumnTableViewGridItem?: GridItemProps;
    rightColumnGridItem?: GridItemProps;
    rightColumnTableViewGridItem?: GridItemProps;
    // Starter Custom Code
    sortSelect?: ProductListSortSelectStyles;
    drawer?: DrawerPresentationProps;
    drawerContentWrapper?: InjectableCss;
    drawerApplyWrapper?: InjectableCss;
    drawerApplyButton?: ButtonPresentationProps;
    resultsTabGroup?: TabGroupPresentationProps;
    tabProducts?: TabPresentationProps;
    tabContents?: TabPresentationProps;
    resultsSelect?: SelectPresentationProps;
    contentsGridItem?: GridItemProps;
}

export const columnsStyles: ProductListColumnsStyles = {
    container: {
        ...baseGridHiddenProps.container,
        css: css`
            ${baseGridHiddenProps.container?.css}
            ${wrapperStyles()}
        `,
    },
    resultsTabGroup: {
        cssOverrides: {
            wrapper: css`
                ${x => x.theme.tab.groupDefaultProps?.cssOverrides?.wrapper}
                ${wrapperStyles()}
            `,
            tabGroup: css`
                ${x => x.theme.tab.groupDefaultProps?.cssOverrides?.tabGroup}
                justify-content: flex-start;
            `,
        },
    },
    resultsSelect: {
        cssOverrides: {
            formField: css`
                ${x => x.theme.formField.defaultProps?.cssOverrides?.formField}
                ${wrapperStyles()}
            `,
        },
    },
    leftColumnGridItem: baseGridHiddenProps.sideColumn,
    rightColumnGridItem: baseGridHiddenProps.mainColumn,
    sortSelect: {
        select: {
            labelProps: {
                ...filtersProps.title,
                forwardAs: "label",
            },
            cssOverrides: {
                formField: css`
                    ${x => x.theme.formField.defaultProps?.cssOverrides?.formField}
                    ${filtersProps.flatSection?.css}
                `,
                formInputWrapper: css`
                    ${x => x.theme.formField.defaultProps?.cssOverrides?.formInputWrapper}
                    margin-top: 0 !important; /* Remove default spacing between field and label */
                `,
            },
        },
    },
    drawer: {
        cssOverrides: {
            drawerContent: css`
                ${x => x.theme.drawer.defaultProps?.cssOverrides?.drawerContent}
                display: flex;
                height: 100%;
                flex-direction: column;
                justify-content: space-between;
            `,
        },
    },
    drawerContentWrapper: {
        css: css`
            padding: ${pxToRem(16)};
        `,
    },
    drawerApplyWrapper: {
        css: css`
            ${boxStickyStyles()}
            position: sticky;
            bottom: 0;
        `,
    },
    drawerApplyButton: {
        variant: "secondary" /* Store Custom Code */,
        css: css`
            ${x => x.theme.button.secondary.css} /* Store Custom Code */
            width: 100%;
        `,
    },
    contentsGridItem: {
        width: 12,
        css: css`
            display: block;
        `,
    },
};

const styles = columnsStyles;

const ProductListColumns: FC<Props> = ({
    id,
    view,
    // Starter Custom Code
    productListDataView,
    setIsFilterNavOpen,
    updateSearchFields,
}) => {
    /* Starter Removed - leftColumnGridItemStyle & rightColumnGridItemStyle */
    /* Starter Custom Code - Start */
    const baseContentSearchDataView = useContentSearchDataView();
    const contentSearchDataView = usePersistentDataView(baseContentSearchDataView);
    const contentTabTotalItemsCount = (contentSearchDataView as any)?.pagination?.totalItemCount ?? 0;
    const productsLabel = translate("Products ({0})", (productListDataView as any)?.pagination?.totalItemCount ?? 0);
    const contentsLabel = translate("Contents ({0})", contentTabTotalItemsCount);
    const productsKey = constants.contentSearch.tabKey.products;
    const contentsKey = constants.contentSearch.tabKey.contents;
    const isSearchPage = useIsSearchPage();
    const isMobile = useIsBreakpoint(mobileBreakpoint, "down");
    const currentTab = useContentSearchCurrentTab();
    const isFilterNavOpen = useIsFilterNavOpen();
    const closeDrawer = () => setIsFilterNavOpen({ isOpen: false });
    const { extensionContentSearchSettings } = useSettingsCollection();
    const enableContentSearchResults =
        extensionContentSearchSettings && extensionContentSearchSettings.enableContentSearchResults;

    const onTabChange = (event: React.MouseEvent | React.KeyboardEvent, tabKey?: string) => {
        if (tabKey) {
            updateSearchFields({ currentTab: tabKey });
        }
    };

    const onSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        updateSearchFields({ currentTab: event.currentTarget.value });
    };

    const productsTab = useMemo(() => {
        return (
            <GridContainer {...styles.container}>
                <GridItem {...styles.leftColumnGridItem}>
                    <Zone contentId={id} zoneName="Content00" />
                </GridItem>
                <GridItem {...styles.rightColumnGridItem}>
                    <Zone contentId={id} zoneName="Content01" />
                </GridItem>
            </GridContainer>
        );
    }, [styles.container, styles.leftColumnGridItem, styles.rightColumnGridItem, id]);

    const contentsTab = useMemo(() => {
        return (
            <GridContainer {...styles.container}>
                <GridItem {...styles.contentsGridItem}>
                    <Zone contentId={id} zoneName="Content03" />
                </GridItem>
            </GridContainer>
        );
    }, [styles.container, styles.contentsGridItem, id]);
    /* Starter Custom Code - End */

    return (
        <>
            {/* Starter Custom Code - Start */}
            {isSearchPage && enableContentSearchResults ? (
                <>
                    {isMobile ? (
                        <>
                            <Select {...styles.resultsSelect} value={currentTab} onChange={onSelectChange}>
                                <option key={productsKey} value={productsKey}>
                                    {productsLabel}
                                </option>
                                <option key={contentsKey} value={contentsKey}>
                                    {contentsLabel}
                                </option>
                            </Select>
                            {currentTab === productsKey ? productsTab : contentsTab}
                        </>
                    ) : (
                        <TabGroup {...styles.resultsTabGroup} current={currentTab} onTabChange={onTabChange}>
                            <Tab
                                {...styles.tabProducts}
                                headline={productsLabel}
                                key={productsKey}
                                tabKey={productsKey}
                            >
                                {productsTab}
                            </Tab>
                            <Tab
                                {...styles.tabContents}
                                headline={contentsLabel}
                                key={contentsKey}
                                tabKey={contentsKey}
                            >
                                {contentsTab}
                            </Tab>
                        </TabGroup>
                    )}
                </>
            ) : (
                productsTab
            )}
            <Drawer
                draggable
                position="left"
                isOpen={isFilterNavOpen}
                handleClose={closeDrawer}
                contentLabel={translate("Sort & Filter")}
                headline={translate("Sort & Filter")}
                {...styles.drawer}
            >
                <StyledWrapper {...styles.drawerContentWrapper}>
                    <SortSelect
                        fields={{}}
                        uid="productListSortSelectMobile"
                        labelPosition="top"
                        extendedStyles={styles.sortSelect}
                    />
                    <Zone contentId={id} zoneName="Content00" />
                </StyledWrapper>
                <StyledWrapper {...styles.drawerApplyWrapper}>
                    <Button onClick={closeDrawer} {...styles.drawerApplyButton}>
                        {translate("PLP_apply_filter") /* Store Custom Code */}
                    </Button>
                </StyledWrapper>
            </Drawer>
            {/* Starter Custom Code - End */}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(ProductListColumns), // Starter Custom Code
    definition: {
        group: "Product List",
        displayName: "Columns",
        allowedContexts: ["ProductListPage"],
    },
};

export default widgetModule;
